import { css, unsafeCSS } from 'lit';
import { fsFontWeightSemibold } from '@cof/fs-tokens';

export const style = css`
  .message-container {
    align-items: center;
    display: flex;
    flex-direction: column;
    text-align: center;
  }

  .title-text {
    font-weight: ${unsafeCSS(fsFontWeightSemibold)};
    text-align: center;
  }
  .txt {
    padding-top: 1em;
  }
`;
